import _ from 'lodash';
import React, { Component } from 'react';
import axios from 'axios';
import { Dimmer, Divider, Search as SearchInput } from 'semantic-ui-react';

import { Document } from '../Document';
import { DocumentList } from '../DocumentList';
import styles from './styles';

class Search extends Component {
  state = {
    selectedDocument: null,
  };

  componentWillMount() {
    this.resetComponent();
  }

  resetComponent = () =>
    this.setState({
      isLoading: false,
      value: '',
      results: [],
    });

  resultRenderer = ({ title, description }) => [
    <div key="content" className="content">
      {title && <div className="title">{title}</div>}
      {description && <div className="description">{description}</div>}
    </div>,
  ];

  performSearch = _.debounce((value, page = 1) => {
    axios
      .get(`/documents/search?q=${value}&s=${(page - 1) * 10}`)
      .then((res) => {
        window.scrollTo(0, 0);
        this.setState({
          isLoading: false,
          results: res.data,
        });
      })
      .catch(() => {
        this.setState({
          isLoading: false,
          results: {
            docs: [{ title: 'Erro ☹️', description: 'Não foi possível fazer a pesquisa' }],
          },
        });
      });
  }, 750);

  handleSearchChange = (e, { value }) => {
    this.setState({ isLoading: !(value.length < 3), value, detailedSearch: undefined });

    if (value.length < 1) return this.resetComponent();

    return this.performSearch(value);
  };

  handleResultSelect = (e, { result }) => {
    this.setState({
      detailedSearch: false,
      selectedDocument: result,
    });
  };

  handleFormSubmit = (event) => {
    event.preventDefault();
    if (this.state.results.docs && this.state.results.docs.length > 0) {
      document.getElementById('search-input').blur();
      this.setState({
        detailedSearch: true,
        selectedDocument: null,
      });
    } else {
      this.setState({
        detailedSearch: false,
      });
    }
  };

  handlePageChange = (event) => {
    const page = event.target.getAttribute('value');
    this.setState({ isLoading: true });
    return this.performSearch(this.state.value, page);
  };

  render() {
    const { isLoading, value, results } = this.state;

    return (
      <div style={styles.container}>
        <h4>Pesquisa de documentos</h4>
        <p>Digite qualquer termo e veja os resultados imediatamente</p>
        <form onSubmit={this.handleFormSubmit}>
          <SearchInput
            loading={isLoading}
            minCharacters={3}
            noResultsMessage="Nenhum resultado encontrado"
            onSearchChange={this.handleSearchChange}
            results={results && results.docs}
            resultRenderer={this.resultRenderer}
            value={value}
            aligned="center"
            onResultSelect={this.handleResultSelect}
            fluid
            id="search-input"
          />
        </form>
        {this.state.selectedDocument && (
          <div>
            <Divider style={{ margin: '40px 0' }} />
            <Document content={this.state.selectedDocument} />
          </div>
        )}

        {!!this.state.detailedSearch && (
          <div>
            <Divider style={{ margin: '40px 0' }} />
            <div>
              <Dimmer active={isLoading} />
              <DocumentList
                showPagination
                activePage={1}
                totalResults={this.state.results.count}
                totalPages={Math.ceil(this.state.results.count / 10)}
                documents={this.state.results.docs}
                onPageChange={this.handlePageChange}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Search;



// WEBPACK FOOTER //
// ./src/components/Search/Search.js